class ProductConfigDrawer {
  static SELECTORS = {
    drawer: "#ProductConfigDrawer",
    drawerContent: "[data-drawer-content]",
    drawerSummary: "[data-drawer-summary]",
    drawerDetails: "[data-drawer-details]",
    drawerPrice: "[data-drawer-price]",
    drawerCTA: "[data-drawer-cta]",
    drawerClose: "[data-drawer-close]",
    drawerBackdrop: '[data-drawer-backdrop]',
    apoBlock: "#mw-apo-app-block",
    apoOption: ".mw-option",
    apoPrice: ".mw-apo-price-custom",
    productForm: 'form[action*="/cart/add"]',
    addToCartButton: ".mw-apo-add-to-cart-cloned, .single-add-to-cart-button",
    triggerContainer: ".add_to_cart_holder",
  };

  static CLASSES = {
    drawerOpen: "product-config-drawer--open",
    bodyLock: "drawer-open",
    loading: "is-loading",
    hidden: "is-hidden",
    hasError: "has-error",
    errorVisible: "is-visible",
  };

  static ATTRIBUTES = {
    ariaHidden: "aria-hidden",
    ariaBusy: "aria-busy",
    hidden: "hidden",
  };

  static TIMING = {
    apoCheckInterval: 100,
    apoMaxAttempts: 100,
    syncDelay: 150,
    scrollDelay: 300,
    clickDelay: 200,
    errorDuration: 3000,
  };

  constructor() {
    this.elements = this.cacheElements();

    if (!this.elements.drawer) {
      console.warn("[ProductConfigDrawer] Drawer element not found");
      return;
    }

    this.state = {
      isOpen: false,
      isInitialized: false,
      apoLoaded: false,
    };

    this.observers = [];
    this.init();
  }

  cacheElements() {
    return {
      drawer: document.querySelector(ProductConfigDrawer.SELECTORS.drawer),
      drawerContent: document.querySelector(
        ProductConfigDrawer.SELECTORS.drawerContent,
      ),
      drawerSummary: document.querySelector(
        ProductConfigDrawer.SELECTORS.drawerSummary,
      ),
      drawerDetails: document.querySelector(
        ProductConfigDrawer.SELECTORS.drawerDetails,
      ),
      drawerPrice: document.querySelector(
        ProductConfigDrawer.SELECTORS.drawerPrice,
      ),
      drawerCTA: document.querySelector(
        ProductConfigDrawer.SELECTORS.drawerCTA,
      ),
      drawerClose: document.querySelector(
        ProductConfigDrawer.SELECTORS.drawerClose,
      ),
      backdrop: document.querySelector(ProductConfigDrawer.SELECTORS.drawerBackdrop),
      productForm: document.querySelector(
        ProductConfigDrawer.SELECTORS.productForm,
      ),
      addToCartButton: document.querySelector(
        ProductConfigDrawer.SELECTORS.addToCartButton,
      ),
      triggerContainer: document.querySelector(
        ProductConfigDrawer.SELECTORS.triggerContainer,
      ),
    };
  }

  init() {
    this.hideOriginalAPO();
    this.createValidationError();
    this.bindEvents();
    this.createTriggerButton();
    this.waitForAPO();
  }

  hideOriginalAPO() {
    const apoBlock = document.querySelector(
      ProductConfigDrawer.SELECTORS.apoBlock,
    );
    const apoPrice = document.querySelector(
      `${ProductConfigDrawer.SELECTORS.productForm} ${ProductConfigDrawer.SELECTORS.apoPrice}`,
    );

    if (apoBlock) apoBlock.style.display = "none";
    if (apoPrice) apoPrice.style.display = "none";
  }

  createValidationError() {
    const errorEl = document.createElement("div");
    errorEl.className = "product-config-drawer__validation-error";
    errorEl.setAttribute("role", "alert");
    errorEl.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" fill="currentColor" fill-opacity="0.1"/>
        <path d="M10 6V10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <circle cx="10" cy="13" r="1" fill="currentColor"/>
      </svg>
      <span class="error-message"></span>
    `;

    this.elements.drawerSummary.insertBefore(
      errorEl,
      this.elements.drawerSummary.firstChild,
    );
    this.elements.validationError = errorEl;
  }

  bindEvents() {
    if (this.elements.drawerClose) {
      this.elements.drawerClose.addEventListener("click", () => this.close());
    }

    if (this.elements.backdrop) {
      this.elements.backdrop.addEventListener('click', () => this.close());
    }

    if (this.elements.drawerCTA) {
      this.elements.drawerCTA.addEventListener("click", () =>
        this.handleAddToCart(),
      );
    }

    document.addEventListener("keydown", (e) => this.handleKeyboard(e));
  }

  handleKeyboard(event) {
    if (event.key === "Escape" && this.state.isOpen) {
      this.close();
    }
  }

createTriggerButton() {
  const triggers = document.querySelectorAll('.product-config-drawer-trigger');

  if (triggers.length === 0) {
    console.warn("[ProductConfigDrawer] No trigger buttons found");
    return;
  }

  triggers.forEach((trigger, index) => {
    if (trigger.hasAttribute('data-config-listener-added')) return;

    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation(); 
      console.log("[ProductConfigDrawer] Trigger clicked from", trigger.closest('.product-add-to-cart-sticky') ? 'sticky' : 'main area');
      this.open();
    });

    trigger.setAttribute('data-config-listener-added', 'true');
  });

  console.log(`[ProductConfigDrawer] Attached listeners to ${triggers.length} trigger button(s)`);
}

  waitForAPO() {
    let attempts = 0;

    const checkAPO = setInterval(() => {
      attempts++;

      const apoBlock = document.querySelector(
        ProductConfigDrawer.SELECTORS.apoBlock,
      );
      const apoPrice = document.querySelector(
        ProductConfigDrawer.SELECTORS.apoPrice,
      );

      if (apoBlock && apoPrice) {
        clearInterval(checkAPO);
        this.initializeAPO(apoBlock);
      } else if (attempts >= ProductConfigDrawer.TIMING.apoMaxAttempts) {
        clearInterval(checkAPO);
        this.handleAPOError();
      }
    }, ProductConfigDrawer.TIMING.apoCheckInterval);
  }

  initializeAPO(apoBlock) {
  const loadingElement = this.elements.drawerContent.querySelector(".product-config-drawer__loading");
  if (loadingElement) loadingElement.remove();

  this.elements.drawerContent.appendChild(apoBlock);

  apoBlock.style.display = 'block';
  apoBlock.style.position = 'relative';

  // Re-cache addToCartButton now that APO is loaded and in the drawer
  this.elements.addToCartButton = this.elements.drawerContent.querySelector(
    ProductConfigDrawer.SELECTORS.addToCartButton
  ) || document.querySelector(ProductConfigDrawer.SELECTORS.addToCartButton);

  this.observePriceChanges();
  this.state.apoLoaded = true;
  this.state.isInitialized = true;
}

  syncOptionWithOriginal(clonedOption) {
    const inputs = clonedOption.querySelectorAll("input, select");

    inputs.forEach((input) => {
      const originalInput = document.querySelector(
        `${ProductConfigDrawer.SELECTORS.apoBlock} [name="${input.name}"]`,
      );

      if (!originalInput) return;

      input.addEventListener("change", () => {
        this.syncInputValue(input, originalInput);
        originalInput.dispatchEvent(new Event("change", { bubbles: true }));
        setTimeout(
          () => this.updateSummary(),
          ProductConfigDrawer.TIMING.syncDelay,
        );
      });

      originalInput.addEventListener("change", () => {
        this.syncInputValue(originalInput, input);
      });
    });
  }

  syncInputValue(source, target) {
    if (source.type === "radio" || source.type === "checkbox") {
      target.checked = source.checked;
    } else {
      target.value = source.value;
    }
  }

  observePriceChanges() {
    const apoPrice = document.querySelector(
      ProductConfigDrawer.SELECTORS.apoPrice,
    );

    if (!apoPrice) return;

    const observer = new MutationObserver(() => {
      this.updateSummary();
    });

    observer.observe(apoPrice, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    this.observers.push(observer);
  }

  updateSummary() {
    this.updatePrice();
    this.updateDetails();
  }

  updatePrice() {
    const apoPrice = document.querySelector(
      ProductConfigDrawer.SELECTORS.apoPrice,
    );

    if (!apoPrice || !this.elements.drawerPrice) return;

    const priceText = apoPrice.querySelector(".mw-text--style-strong");

    if (priceText) {
      this.elements.drawerPrice.textContent = priceText.textContent;
    }
  }

  updateDetails() {
    if (!this.elements.drawerDetails) return;

    const summaryItems = this.collectSummaryItems();

    this.elements.drawerDetails.innerHTML =
      summaryItems.length > 0
        ? summaryItems.map((item) => this.renderSummaryRow(item)).join("")
        : '<p class="summary-empty">Geen opties geselecteerd</p>';
  }

  collectSummaryItems() {
    const items = [];
    const options = this.elements.drawerContent.querySelectorAll(
      ProductConfigDrawer.SELECTORS.apoOption,
    );

    options.forEach((option) => {
      const label = option.querySelector(".mw-label .mw-text--style-strong");
      if (!label) return;

      let value = "";

      const select = option.querySelector("select");
      if (select && select.value) {
        const selectedOption = select.options[select.selectedIndex];
        value = selectedOption ? selectedOption.text : "";
      }

      const radio = option.querySelector('input[type="radio"]:checked');
      if (radio) {
        const radioLabel = option.querySelector(
          `label[for="${radio.id}"] .mw-option__value-text`,
        );
        value = radioLabel ? radioLabel.textContent.trim() : "";
      }

      if (value) {
        value = value.replace(/\([+\-€].*?\)/g, "").trim();

        items.push({
          label: this.cleanLabel(label.textContent),
          value: value,
        });
      }
    });

    return items;
  }

  cleanLabel(label) {
    return label.replace(/[*?:]/g, "").trim();
  }

  renderSummaryRow(item) {
    return `
      <div class="summary-row">
        <span class="summary-label">${this.escapeHtml(item.label)}:</span>
        <span class="summary-value">${this.escapeHtml(item.value)}</span>
      </div>
    `;
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }

  validateOptions() {
    const requiredOptions = document.querySelectorAll(
      `${ProductConfigDrawer.SELECTORS.apoBlock} .mw-option--required`,
    );

    this.clearValidationErrors();

    let isValid = true;
    const invalidFields = [];

    for (const option of requiredOptions) {
      const select = option.querySelector("select");
      const radio = option.querySelector('input[type="radio"]:checked');

      if ((select && !select.value) || (!select && !radio)) {
        isValid = false;

        const drawerOption = this.findDrawerOption(option);
        if (drawerOption) {
          drawerOption.classList.add(ProductConfigDrawer.CLASSES.hasError);

          const label = option.querySelector(
            ".mw-label .mw-text--style-strong",
          );
          if (label) {
            invalidFields.push(this.cleanLabel(label.textContent));
          }
        }
      }
    }

    if (!isValid) {
      const drawerTexts =
        (window.shopTranslations && window.shopTranslations.productConfigDrawer) || {};
      const message =
        invalidFields.length > 0
          ? (drawerTexts.requiredField || 'Vul het veld "[veld]" in').replace(
              "[veld]",
              () => invalidFields[0],
            )
          : drawerTexts.requiredAll || "Vul alle verplichte velden in";

      this.showValidationError(message);

      const firstError = this.elements.drawerContent.querySelector(
        `.${ProductConfigDrawer.CLASSES.hasError}`,
      );
      if (firstError) {
        firstError.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }

    return isValid;
  }

  findDrawerOption(originalOption) {
    const originalId =
      originalOption.getAttribute("id") ||
      originalOption.getAttribute("data-option-id");
    if (!originalId) return null;

    return this.elements.drawerContent.querySelector(
      `[id="${originalId}"], [data-option-id="${originalId}"]`,
    );
  }

  showValidationError(message) {
    if (!this.elements.validationError) return;

    const messageEl =
      this.elements.validationError.querySelector(".error-message");
    if (messageEl) {
      messageEl.textContent = message;
    }

    this.elements.validationError.classList.add(
      ProductConfigDrawer.CLASSES.errorVisible,
    );

    setTimeout(() => {
      this.clearValidationErrors();
    }, ProductConfigDrawer.TIMING.errorDuration);
  }

  clearValidationErrors() {
    if (this.elements.validationError) {
      this.elements.validationError.classList.remove(
        ProductConfigDrawer.CLASSES.errorVisible,
      );
    }

    const errorFields = this.elements.drawerContent.querySelectorAll(
      `.${ProductConfigDrawer.CLASSES.hasError}`,
    );
    errorFields.forEach((field) => {
      field.classList.remove(ProductConfigDrawer.CLASSES.hasError);
    });
  }

  async handleAddToCart() {
  if (!this.validateOptions()) {
    return;
  }

  const addToCartButton = 
    this.elements.addToCartButton ||
    this.elements.drawerContent.querySelector(ProductConfigDrawer.SELECTORS.addToCartButton) ||
    document.querySelector(ProductConfigDrawer.SELECTORS.addToCartButton);

  if (!addToCartButton) {
    console.error("[ProductConfigDrawer] Add to cart button not found");
    return;
  }

  this.setLoading(true);
  this.showGlobalLoadingOverlay(true);

  this.close();

  try {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      const url = typeof args[0] === "string" ? args[0] : (args[0]?.url || "");

      if (url.includes("/cart/add")) {
        window.fetch = originalFetch; 
        if (response.ok) {
          window.location.href = "/checkout";
        } else {
          this.resetLoading();
        }
      }
      return response;
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this._url = url;
      return originalOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      this.addEventListener("load", function () {
        if (this._url && this._url.includes("/cart/add") && this.status >= 200 && this.status < 300) {
          XMLHttpRequest.prototype.open = originalOpen;
          XMLHttpRequest.prototype.send = originalSend;
          window.location.href = "/checkout";
        }
      });
      return originalSend.apply(this, args);
    };

    await this.wait(ProductConfigDrawer.TIMING.clickDelay || 200);

    addToCartButton.click();

    setTimeout(() => {
      this.resetLoading();
      window.location.href = "/checkout";
    }, 8000);

  } catch (err) {
    console.error("[ProductConfigDrawer] Add to cart error:", err);
    this.resetLoading();
  }
}

resetLoading() {
  this.setLoading(false);
  this.showGlobalLoadingOverlay(false);
}
showGlobalLoadingOverlay(show = true) {
  let overlay = document.getElementById("global-atc-overlay");

  if (!overlay) {
    overlay = document.createElement("div");
    overlay.id = "global-atc-overlay";
    overlay.style.cssText = `
      position: fixed; inset: 0; background: rgba(255,255,255,0.97); 
      z-index: 99999; display: none; align-items: center; justify-content: center; 
      flex-direction: column; color: #333;
    `;

    overlay.innerHTML = `
      <div style="width: 48px; height: 48px; border: 5px solid #eee; border-top-color: #000; 
                  border-radius: 50%; animation: spin 0.9s linear infinite; margin-bottom: 20px;"></div>
      <p style="margin:0; font-size: 18px;" id="loading-title"></p>
      <p style="margin:8px 0 0; font-size:14px; color:#666;" id="loading-subtitle"></p>
    `;

    document.body.appendChild(overlay);

    if (!document.getElementById('spinner-style')) {
      const style = document.createElement("style");
      style.id = 'spinner-style';
      style.textContent = `@keyframes spin { to { transform: rotate(360deg); } }`;
      document.head.appendChild(style);
    }
  }

  const titleEl = overlay.querySelector('#loading-title');
  const subtitleEl = overlay.querySelector('#loading-subtitle');

  if (titleEl) titleEl.textContent = window.shopTranslations?.productConfigDrawer?.loadingTitle || "Bezig met toevoegen...";
  if (subtitleEl) subtitleEl.textContent = window.shopTranslations?.productConfigDrawer?.loadingSubtitle || "Je wordt doorgestuurd naar de checkout";

  overlay.style.display = show ? "flex" : "none";
}
  setLoading(loading) {
    if (!this.elements.drawerCTA) return;

    this.elements.drawerCTA.setAttribute(
      ProductConfigDrawer.ATTRIBUTES.ariaBusy,
      loading.toString(),
    );

    const text = this.elements.drawerCTA.querySelector(
      ".product-config-drawer__cta-text",
    );
    const loader = this.elements.drawerCTA.querySelector(
      ".product-config-drawer__cta-loader",
    );

    if (text) text.style.opacity = loading ? "0" : "1";
    if (loader) loader.hidden = !loading;
  }

  handleAPOError() {
    console.error("[ProductConfigDrawer] APO failed to load");

    if (this.elements.drawerContent) {
      this.elements.drawerContent.innerHTML = `
        <div class="product-config-drawer__error">
          <p>Product opties konden niet worden geladen.</p>
          <p>Probeer de pagina opnieuw te laden.</p>
        </div>
      `;
    }
  }

  open() {
    this.state.isOpen = true;
    this.clearValidationErrors();

    this.elements.backdrop.removeAttribute(ProductConfigDrawer.ATTRIBUTES.hidden);
    this.elements.drawer.setAttribute(
      ProductConfigDrawer.ATTRIBUTES.ariaHidden,
      "false",
    );
   
    document.body.classList.add("drawer-open");
    this.elements.drawer.focus();
    this.dispatchEvent("drawer:opened");
  }

  close() {
    this.state.isOpen = false;

    this.elements.backdrop.setAttribute(ProductConfigDrawer.ATTRIBUTES.hidden, '');
    this.elements.drawer.setAttribute(
      ProductConfigDrawer.ATTRIBUTES.ariaHidden,
      "true",
    );

    document.body.classList.remove("drawer-open");
    this.dispatchEvent("drawer:closed");
  }

  dispatchEvent(eventName, detail = {}) {
    const event = new CustomEvent(eventName, {
      detail: { drawer: this, ...detail },
      bubbles: true,
    });

    this.elements.drawer.dispatchEvent(event);
  }

  wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  destroy() {
    this.observers.forEach((observer) => observer.disconnect());
    this.observers = [];
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initDrawer);
} else {
  initDrawer();
}

function initDrawer() {
  if (document.querySelector("#ProductConfigDrawer")) {
    window.productConfigDrawer = new ProductConfigDrawer();
  }
}

if (typeof module !== "undefined" && module.exports) {
  module.exports = ProductConfigDrawer;
}

document.addEventListener('click', function(e) {
  const sticky = e.target.closest('product-add-to-cart-sticky');
  if (!sticky) return;

  const innerButton = sticky.querySelector('.product-add-to-cart-sticky--inner');
  if (e.target.closest('.product-config-drawer-trigger') || !innerButton) return;

  sticky.classList.toggle('is-open');
});